module Blocks {
    export interface IRouter extends ng.IModule { }

    export class Router {
        static moduleId: string = 'blocks.router';
    }

    // Create the module and define its dependencies.
    export var router: IRouter = angular.module(Router.moduleId, ['ui.router']);

    // Execute bootstrapping code and any dependencies.
    router.run([() => { }]);
}
